module.exports = __webpack_public_path__ + "static/media/bold.7d6efb29.svg";